/**
 * @Author:
 * @Description:
 * @DateTime: Created in 15:56 2019-08-06
 */

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:46 2019-07-09
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import {GridOptions} from "ag-grid-community";
import {default as AgGridVueCustomTsx, ColDefCustom} from "../../components/agGridCustom/agGridVueCustomTsx";
import {defaultPageSize} from "../../config";
import IconBtnGroup, {IconBtnItem} from "../../components/iconBtnGroup/iconBtnGroup";
import QueryForm, {QueryFormVOI} from "../../components/queryForm/queryForm";
import ListPageService from "../../types/ListPage";
import './basicSearchPage.less'
import MenuBtn from 'src/pages/layout/components/menuBtn';
import { createNamespace } from 'src/util/bem';
@Component
export default class BasicSearchPage<S extends ListPageService, R, P> extends Vue.Component<any> {
	constructor() {
		super()
		this.loadService()
	}

	breadcrumb!:{title: string, href?: string}[]

	service!: S

	gridOptions: GridOptions = {}

    columnDefs: ColDefCustom[] = []
    
    className: string = ''

	total: number = 0

	currentPage: number = 1

	pageSize: number = defaultPageSize

	rowData: R[] = []

	btnGroup!: IconBtnItem[]

	queryFormData: QueryFormVOI.DateItemType[] = []

	searchParams!: P

	enableColResize: boolean = true

	checkBoxShow: boolean = false

	pageShow: boolean = true

	needColControl: boolean = false

	timeout:any = null

	zoom!: boolean = true; //缩放图标状态

    @Prop({
        type: Boolean,
        default: false,
    })
    showZoom!: boolean; //缩放图标是否显示

	get queryForm (): QueryForm {
		return this.$refs.queryForm as QueryForm
	}

	get ag (): AgGridVueCustomTsx {
		return this.$refs.ag as AgGridVueCustomTsx
	}

	search () {
		this.service.initSearchParams()
		this.service.searchTable()
	}

	pageSizeChanged (pageSize: number) {
		this.pageSize = pageSize
		this.service.searchTable()
	}

	pageChanged (page: number) {
		this.currentPage = page
		this.service.searchTable()
	}

	rowDragEndHandler(event: any) {
		this.service.dragRow(event)
	}

	loadService () {

	}
    
	zoomFlags() {
        this.zoom = !this.zoom
		this.$emit('zoomFlag', this.zoom)
		if(!this.zoom){
			setTimeout(() => {
				this.$refs.ag.sizeColumnsToFit();
			 }, 100);
		}
    }

	renderWapper (h) {
		return <div class={createNamespace('page-containeraa')}>
		<div class={createNamespace('page-siad-operation')} style="float: left; height: 100%; width: 15px;">
		     <img v-if={this.showZoom === true && this.zoom === true} src={require('../../assets/images/隐藏.png')} style="width: 15px; height:20px;position:absolute;top:50%;" onClick={this.zoomFlags}/>
			 <img v-if={this.showZoom === true && this.zoom === false} src={require('../../assets/images/显示.png')} style="width: 15px; height:20px;position:absolute;top:50%;" onClick={this.zoomFlags}/>
		</div>
		<div class={[createNamespace('page-container'), this.className]}>
        {
            this.renderHead(h)
        }
        <div class={createNamespace('basic-page-head')}>
        {
            this.renderQuery(h)
        }
        {
            this.renderOperate(h)
        }
        </div>
        {
            this.renderTable(h)
        }
        {
            this.renderFooter(h)
        }
    </div></div>
    }
    renderOperate(h) {
        return this.btnGroup.length>0 ? <IconBtnGroup  class={createNamespace('mb10')}  dataSource={this.btnGroup}/>: null
    }
    renderHead(h) {
        return <MenuBtn class={createNamespace('mb10')}></MenuBtn>
    }
	renderQuery(h) {
		return <QueryForm ref="queryForm" dataSource={this.queryFormData} on-search={this.search}/>
	}
	renderFooter(h) {
		return <div></div>
	}

	renderTable(h) {
		return <AgGridVueCustomTsx
            class={createNamespace('page-table')}
			ref="ag"
			enableColResize={this.enableColResize}
			needColControl={this.needColControl}
			gridOptions={this.gridOptions}
			columnDefs={this.columnDefs}
			rowData={this.rowData}
			total={this.total}
			current={this.currentPage}
			pageSize={this.pageSize}
			enableServerSideSorting={false}
			checkBoxShow={this.checkBoxShow}
			pageShow={this.pageShow}
			pageChanged={this.pageChanged}
			pageSizeChanged={this.pageSizeChanged}
			RowDragEnd={this.rowDragEndHandler}
		/>
	}

	searchTable() {
		clearTimeout(this.timeout)
		this.timeout = setTimeout(()=>{
			this.service.searchTable()
		},0)
	}

	lifyCreated() {
		this.columnDefs = this.service.createColumns()
		this.btnGroup = this.service.createBtnGroup()
		this.queryFormData = this.service.creatQueryForm()
	}

	activated() {
		this.searchTable()
	}

	mounted () {
		this.service.initSearchParams()
		this.searchTable()
	}

	created () {
		this.lifyCreated()
	}
	beforeDestroy() {
		this.timeout = null
	}

	render (h) {
		return this.renderWapper(h)
	}
}
